<template>
    <b-container>
        <Spinner size="32" message="Loading..." style="margin:0,auto" v-if="isLoading"></Spinner>
        <b-alert
            :show="showDismissibleAlert"
            dismissible
            @dismissed="showDismissibleAlert=false"
            :variant="variant"
        >{{alertText}}</b-alert>
        <b-alert :show="!isLoading && !LOI.LOINumber && !showDismissibleAlert" variant="warning">
            No LOI found for this application (ApplicationID: {{ApplicationID}}). If an LOI extension was recently approved by AGM, please refresh the page or contact admin.
        </b-alert>
        <table style="margin-top:15px;font-size:12pt;" v-if="LOI.LOINumber">
            <tr>
            <td><span style="font-weight: bold;">पात्रता प्रमाणपत्र क्रमांक:</span></td>
            <td><span>{{LOI.LOINumber}}</span></td>
            </tr>
            <tr>
            <td><span style="font-weight: bold;">दिनांक:</span></td>
            <td><span>{{LOI.LOIDate}}</span></td>
            </tr>
            <tr>
            <td><span style="font-weight: bold;">अर्ज क्रमांक:</span></td>
            <td><span>{{LOI.LoanApplicationNo}}</span></td>
            </tr>
            <tr>
            <td style="font-size:12.0pt;font-weight: bold;" v-if="LOI.Gender">श्री:</td>
            <td style="font-size:12.0pt;font-weight: bold;" v-if="!LOI.Gender">सौ/कुमारी/श्रीमती:</td>
            <td><span style="font-size:12.0pt;">{{LOI.ApplicantName}}</span></td>
            </tr>
            <tr>
            <td><span style="font-size:12.0pt;font-weight: bold;">आधार क्रमांक:</span></td>
            <td><span style="font-size:12.0pt;">{{LOI.AdharNo}}</span></td>
            </tr>
            <tr>
            <td style="font-size:12.0pt;font-weight: bold;">पत्ता:</td>
            <td><span style="font-size:12.0pt;">{{LOI.Address}}</span></td>
            </tr>
            <tr>
                <td>Loan Type: </td>
                <td>
                    <span v-if="Loantype==2 || Loantype=='2'">गट कर्ज व्याज परतावा</span>
                    <span v-if="Loantype==1 || Loantype=='1'">वैयक्तिक कर्ज व्याज परतावा</span>
                </td>
            </tr>
            <tr>
                <td>Business Type: </td>
                <td>{{LOI.BusinessName}}</td>
            </tr>
        </table>
    </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import logger from "@/utils/logger";
export default {
  components: { Spinner },
  props: ["ApplicationID", "Loantype", "UserID"],
  data() {
    return {
      LOI: {
        LoanApplicationNo: "",
        ApplicationDate: "",
        ApplicantName: "",
        AdharNo: "",
        Address: "",
        LOIDate: "",
        LOINumber: "",
        BusinessName: "",
        Division: "" //Konkan
      },
      isLoading: false,
      alertText: "",
      showDismissibleAlert: false,
      variant: "danger"
    };
  },
  watch: {
    ApplicationID:{
        immediate:true,
        handler(newValue, oldValue) {
        this.getLOI();
    }}
  },
  methods: {
    getLOI() {
      this.isLoading = true;
      this.showDismissibleAlert = false;
      let promiseU = apis.ReadLOI(this.ApplicationID); //Personal Details
      promiseU
        .then(response => {
          if (response.status == 200) {
            const parsed = JSON.parse(response.body);
            this.LOI = parsed || {};
            this.isLoading = false;
            if (!this.LOI.LOINumber) {
              logger.warn('[LOIDetails] LOI returned but LOINumber is empty for ApplicationID', this.ApplicationID);
            }
          } else {
            this.alertText = response.body;
            this.isLoading = false;
            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          logger.error('[LOIDetails] ReadLOI error:', err);
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    }
  },
  mounted() {}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ClaimApproval/ClaimComponents/LOIDetails.vue